export default __webpack_public_path__ + "static/media/Golden bow_primary.8bef3490.jpg";